import { createFileRoute } from "@tanstack/react-router";
import ServiceLandingPage from "@/components/ServiceLandingPage";
import { SERVICE_META } from "@/data/servicePageMeta";

const PAGE = SERVICE_META["sprinter-van-images"];
const PAGE_URL = "https://sprinter-van-rentals.com/sprinter-van-images";

export const Route = createFileRoute("/sprinter-van-images")({
  head: () => ({
    meta: [
      { title: PAGE?.title ?? "Sprinter Van Rentals" },
      { name: "description", content: PAGE?.metaDescription ?? "Compare Sprinter van rental options for your city and dates." },
      { property: "og:title", content: PAGE?.title ?? "Sprinter Van Rentals" },
      { property: "og:description", content: PAGE?.metaDescription ?? "Compare Sprinter van rental options for your city and dates." },
      { property: "og:type", content: "article" },
      { property: "og:url", content: PAGE_URL },
      { property: "og:image", content: "https://sprinter-van-rentals.com/sprinter913-91.png" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://sprinter-van-rentals.com/sprinter913-91.png" },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
  }),
  component: () => <ServiceLandingPage slug="sprinter-van-images" />,
});
